"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTablePageSizeDropdown = void 0;
var react_1 = __importDefault(require("react"));
var AcDropdown_1 = require("../dropdown/AcDropdown");
var AcTablePageSizeDropdown = function (_a) {
    var pageSize = _a.pageSize, pageSizes = _a.pageSizes, updatePageSize = _a.updatePageSize;
    var onUpdatePageSize = function (value) {
        if (updatePageSize)
            updatePageSize(value);
    };
    var pageSizeActions = pageSizes && pageSizes.length > 0
        ? pageSizes.map(function (pageSize) { return ({
            name: "pagesize_" + pageSize,
            title: function () { return react_1.default.createElement("span", { className: "pl-2" },
                pageSize,
                "\u4EF6"); },
            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    updatePageSize === null || updatePageSize === void 0 ? void 0 : updatePageSize(pageSize);
                    return [2 /*return*/];
                });
            }); },
        }); })
        : [
            {
                name: 'pagesize_10',
                title: function () { return react_1.default.createElement("span", { className: "pl-2" }, "10\u4EF6"); },
                onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (updatePageSize)
                            updatePageSize(10);
                        return [2 /*return*/];
                    });
                }); },
            },
            {
                name: 'pagesize_30',
                title: function () { return react_1.default.createElement("span", { className: "pl-2" }, "30\u4EF6"); },
                onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (updatePageSize)
                            updatePageSize(30);
                        return [2 /*return*/];
                    });
                }); },
            },
            {
                name: 'pagesize_50',
                title: function () { return react_1.default.createElement("span", { className: "pl-2" }, "50\u4EF6"); },
                onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (updatePageSize)
                            updatePageSize(50);
                        return [2 /*return*/];
                    });
                }); },
            },
        ];
    return (react_1.default.createElement("div", { className: "d-flex flex-row flex-nowrap align-items-center justify-content-end ml-3" },
        react_1.default.createElement(AcDropdown_1.AcDropdown, { menuMinWidth: 125, toggleSize: "sm", toggleVariant: "sub4", dropdownSize: "sm", title: function () { return (react_1.default.createElement("span", { className: "mr-1" },
                react_1.default.createElement("span", { className: "font-weight-normal" }, "\u8868\u793A\u4EF6\u6570\uFF1A"), pageSize + "\u4EF6")); }, data: {}, align: "right", actions: pageSizeActions })));
};
exports.AcTablePageSizeDropdown = AcTablePageSizeDropdown;
exports.AcTablePageSizeDropdown.displayName = 'AcTablePageSizeDropdown';
//# sourceMappingURL=AcTablePageSizeDropdown.js.map